interface Serializer {
  set<T>(key: string, obj: T): void;
  get<T>(key: string): T | null;
  remove(key: string): void;
}

const serializer: Serializer = {
  set<T>(key: string, obj: T): void {
    localStorage.setItem(key, JSON.stringify(obj))
  },
  get<T>(key: string): T | null {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
  },
  remove(key: string): void {
    localStorage.removeItem(key)
  }
}

export default serializer
